import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { getDevelopmentPath } from "@core/schema/paths/getDevelopmentPath.js";
import { getDigitalizationAndAutomationPath } from "@core/schema/paths/getDigitalizationAndAutomationPath.js";
import { getIntegrationsPath } from "@core/schema/paths/getIntegrationsPath.js";
import { getWebAppsPath } from "@core/schema/paths/getWebAppsPath.js";

export function getCoopStepByStepProduction(tenant: Tenant): InfoCardProps[] {
	return [
		{
			desc: "Nejprve se s vámi setkáme (online, nebo osobně) a zjistíme od vás, s čím potřebujete pomoci. Zeptáme se na veškeré detaily, a pokud to bude možné, nahlédneme do zákulisí vašich výrobních procesů, abychom dokázali navrhnout ideální řešení na míru.",
		},
		{
			desc: `Doporučíme, které problémy řešit prioritně a jak postupovat, abyste dosáhli nejlepšího výsledku v poměru cena/výkon.`,
		},
		{
			desc: `Jakmile si odsouhlasíme postup a podmínky spolupráce, pustíme se do [${getDevelopmentPath(tenant)}][[vývoje]], [${getIntegrationsPath(tenant)}][[integrace jednotlivých systémů]] nebo digitalizace a [${getDigitalizationAndAutomationPath(tenant)}][[automatizace]].`,
		},
		{
			desc: "Doladíme s vámi detaily a spustíme tzv. MVP (Minimum viable product – produkt, který splňuje primární cíle, je spustitelný a životaschopný). Na základě MVP můžeme řešení dále rozvíjet a vylepšovat ho.",
		},
		{
			desc: `Budeme vám k ruce s podporou a dalším rozvojem systému, [${getWebAppsPath(
				tenant,
			)}][[webové aplikace]], webu nebo jiného řešení. `,
		},
	];
}
